<template>
  <div class="Tabs" tabindex="0">
    <ul role="tablist" :class="{ 'tabs-line': !icons, 'tabs-icons': icons }">
      <li v-for="(tab, index) in tabs" :key="index" :class="{ 'is-active': tab.isActive }" ref="tab1" role="tab" :aria-selected="(tab.isActive) ? 'true' : 'false'" tabindex="0" @click="selectTab(tab)" @keyup.space="selectTab(tab, $event)">

        <div class="l">
          <div class="tab d-flex">
            <i v-if="tab.icon" class="tab-icon material-icons">{{ tab.icon }}</i>
            <span class="tab-name">{{ tab.name }}</span>
          </div>
        </div>

      </li>
    </ul>

    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    icons: { type: Boolean, default: false }
  },
  data () {
    return {
      tabs: [],
    }
  },
  methods: {
    focus() {
      this.$refs['tab1'][0].focus()
    },
    selectTab(selectedTab, event=null) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name === selectedTab.name)
      })

      if (event) {
        event.stopPropagation()
      }
    },
  },

  created() {
    this.tabs = this.$children
  },
}
</script>